

import { Toaster } from 'react-hot-toast';
// import App from './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Componants/Header/header';
import HomeSlider from './Componants/Home/homeslider';
import CategoryPage from './Componants/Cetagory/CetagoryPage';
// import ProductDetail from './Componants/Cetagory/ProductDetail'; // Removed: This was causing the error
import AllProductsPage from './Componants/Cetagory/AllProductPage';
// import ComboPage from './Componants/ComboPage';
import BlogPage from './Componants/Blog';

import AboutUs from './Componants/AboutUs';

import Footer from './Componants/Footer/footer';
import WhyAyushvatika from './Componants/WhyAyushvatika';
import CheckoutPage from './Componants/PaymentPage/CheckoutPage';
import { CartProvider } from './Componants/PaymentPage/CartContext';

import CartPage from './Componants/Header/CartPage';
import React, { useState, useEffect } from 'react'

import HerbalProductsDescriptionSection from './Componants/DescriptionSection';
import ProfilePage from './Pages/ProfilePage'; // Ensure this import path is correct
import { AuthModal } from '../src/Componants/Header/AuthModal'; // Import AuthModal

import ProductViewPage from './Componants/Cetagory/ProductViewPage';
import LearnAyurvedaPage from './Componants/HeaderCategoryPages/LearnAyurvedaPage';
import DailyRoutinesPage from './Componants/HeaderCategoryPages/DailyRoutinesPage';
import AyurvedicHerbsPage from './Componants/HeaderCategoryPages/AyurvedicHerbs';
import WellnessLifestylePage from './Componants/HeaderCategoryPages/WellnessLifestylePage';
import AyurvedicDietPage from './Componants/HeaderCategoryPages/AyurvedicDietPage ';
import PanchakarmaPage from './Componants/HeaderCategoryPages/PanchakarmaPage';

import AllProductPage from './Componants/Cetagory/AllProductPage';
import TestimonialSlider from './Componants/aboutAyushvatika';



//-------------------------Admin------------------------------------------------------
import LoginPage from './Admin/pages/LoginPage';
import SignupPage from './Admin/pages/SignupPage';
import PrivateRoute from './Admin/components/PrivateRoute';
import CategoryListPage from './Admin/pages/CategoryList';
import AddCategoryPage from './Admin/pages/AddCategory';
import EditCategoryPage from './Admin/pages/EditCategoryPage';
import ProductList from './Admin/pages/ProductList';
import CreateProduct from './Admin/pages/CreateProduct';
import EditProduct from './Admin/pages/EditProduct';
import OrderList from './Admin/pages/OrderList';
import PendingOrder from './Admin/pages/PendingOrder';
import CompletedOrder from './Admin/pages/CompletedOrder';
import DeliveryChargePage from './Admin/pages/DeliveryCharge';
import ReturnedOrderList from './Admin/pages/ReturnedOrderList';
import CancelledOrderList from './Admin/pages/CancelledOrderList';
import PlacedOrderList from './Admin/pages/PlacedOrderList';
import SalesReportPage from './Admin/pages/SalesReport';
import HotLeadsPage from './Admin/pages/HotLeads';
import NewLeadPage from './Admin/pages/NewLead';
import SalesPage from './Admin/pages/SalesPage';
import SubordinatesPage from './Admin/pages/SubordinatesPage';
import PendingApprovalsPage from './Admin/pages/PendingApprovalsPage';
import DashboardPage from './Admin/pages/Dashboard';

import SaleOrder from './Admin/pages/SaleOrder';
import UnverifiedOrders from './Admin/pages/UnverifiedOrders';
import VerifiedOrders from './Admin/pages/VerifiedOrders';
import UpdateOrderPage from './Admin/pages/UpdateOrderPage';
import Profile from './Admin/pages/ProfilePage';
import PrivacyPolicy from './Componants/Footer/PrivacyPolicy';
import TermsAndConditions from './Componants/Footer/TermsAndConditions';
import OrderInProcess from './Admin/pages/OrderInProcess';
import ContactPage from './Componants/ContactPage';
import AyushBanner from './Componants/banner';
import AboutAyushVatika from './Componants/aboutAyushvatika';
import CallHistory from './Admin/pages/CallHistory';
import ManageLogistics from './Admin/pages/ManageLogistics';
import BookAppointment from './Componants/BookAppointment';
import ApproveAppointment from './Admin/pages/ApproveAppointment';
import ScheduledAppointments from './Admin/pages/ScheduledAppointments';
import ConsultationRoom from './Pages/ConsultationRoom';
import Reviews from './Componants/Reviews';
import AdminReviews from './Admin/pages/AdminReviews';
import BlogContent from './Componants/BlogContent';
import AdminBlogs from './Admin/pages/AdminBlogs';





// New component to handle scrolling to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// HomeContent component to group all home-specific elements
const HomeContent = () => (
  <>
    <HomeSlider />
    <CategoryPage />
    {/* <ComboPage /> */}

    {/* <HerbalCommitment /> */}
     <WhyAyushvatika />
     <AyushBanner />
     <HerbalProductsDescriptionSection />
     <Reviews />
    {/* <TestimonialSlider /> */}
    <AboutAyushVatika />
    
    
    {/* <ComingSoonBanner /> */}
   
    {/* <DeliveryPartners /> */}
  </>
);

const AppContent = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [user, setUser] = useState<{
    id?: string;
    name: string;
    email: string;
    picture?: string;
    mobile?: string;
    gender?: string;
  } | null>(null);

  const location = useLocation();
  const isConsultationRoom = location.pathname.startsWith("/consultation-room/");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse user from local storage", e);
        localStorage.removeItem("user");
      }
    }
  }, []);

  const handleToggleSidebar = (isOpen: boolean) => {
    setIsSidebarOpen(isOpen);
  };

  const handleLoginSuccess = (loggedInUser: any) => {
    setUser(loggedInUser);
    setShowAuthModal(false);
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  const handleProfileUpdate = (updatedUser: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    mobile?: string;
    profilePictureUrl?: string;
    gender?: string;
  }) => {
    setUser((prevUser) => {
      if (!prevUser) return null;
      return {
        ...prevUser,
        id: updatedUser.id,
        name: `${updatedUser.firstName} ${updatedUser.lastName}`.trim(),
        email: updatedUser.email,
        picture: updatedUser.profilePictureUrl,
        mobile: updatedUser.mobile,
        gender: updatedUser.gender,
      };
    });

    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    localStorage.setItem(
      "user",
      JSON.stringify({
        ...storedUser,
        firstName: updatedUser.firstName,
        lastName: updatedUser.lastName,
        email: updatedUser.email,
        mobile: updatedUser.mobile,
        picture: updatedUser.profilePictureUrl,
        gender: updatedUser.gender,
      })
    );
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Toaster position="top-center" reverseOrder={false} />

      {!isConsultationRoom && (
        <Header
          onToggleSidebar={handleToggleSidebar}
          user={user}
          setShowAuthModal={setShowAuthModal}
          onLogout={handleLogout}
        />
      )}

      {!isConsultationRoom && isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <main
        className={
          isConsultationRoom
            ? "min-h-screen flex-grow"
            : `flex-grow pt-2 transition-all duration-300 ease-in-out ${
                isSidebarOpen ? "md:ml-64" : "md:ml-0"
              }`
        }
      >
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<HomeContent />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/all-products" element={<AllProductsPage />} />
          <Route path="/checkoutpage" element={<CheckoutPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/reviews"element={<Reviews />}/>
          <Route path="/contact-us" element={<ContactPage />} />

          <Route path="/explore-ayushvatika" element={<LearnAyurvedaPage />} />
          <Route path="/learn-ayurveda/routines" element={<DailyRoutinesPage />} />
          <Route path="/learn-ayurveda/herbs" element={<AyurvedicHerbsPage />} />
          <Route path="/learn-ayurveda/wellness" element={<WellnessLifestylePage />} />
          <Route path="/learn-ayurveda/diet" element={<AyurvedicDietPage />} />
          <Route path="/learn-ayurveda/panchakarma" element={<PanchakarmaPage />} />

          <Route
            path="/settings"
            element={
              <ProfilePage
                onLogout={handleLogout}
                onProfileUpdate={handleProfileUpdate}
              />
            }
          />

          <Route
    path="/blogs/:slug"
    element={<BlogContent />}
/>

          <Route path="/make-profit" element={<div>Make Profit Page Content</div>} />
          <Route path="/offers" element={<div>Offers Page Content</div>} />
          <Route path="/faq" element={<div>FAQ Page Content</div>} />
          <Route path="/collection/:collectionPath" element={<div>Collection Page Content</div>} />

          <Route path="/product/:slug" element={<ProductViewPage />} />
          <Route path="/category/:parentSlug/:childSlug" element={<AllProductPage />} />
          <Route path="/category/:parentSlug" element={<AllProductPage />} />
          <Route path="/category/:categoryId" element={<AllProductPage />} />

          <Route path="/book-appointments" element={<BookAppointment />} />

          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/term&condition" element={<TermsAndConditions />} />

          {/* Consultation room ko normal header/footer se alag full-screen page banaya */}
          <Route path="/consultation-room/:roomId" element={<ConsultationRoom />} />
        </Routes>
      </main>

      {!isConsultationRoom && <Footer />}

      {!isConsultationRoom && (
        <a
          href="https://wa.me/919412220200"
          className="fixed bottom-5 right-5 z-10 rounded-full p-2 shadow-lg transition hover:scale-105"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/Whatsapp.webp" alt="WhatsApp" className="h-14 w-14" />
        </a>
      )}

      {!isConsultationRoom && showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </div>
  );
};


function AdminRoutes() {
  return (
    <Routes>
      
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin/signup" element={<SignupPage />} />

      <Route element={<PrivateRoute />}>

      
        <Route path="/admin/dashboard" element={<DashboardPage />} />

        {/* Category */}
        <Route path="/admin/category/list" element={<CategoryListPage />} />
        <Route path="/admin/category/add" element={<AddCategoryPage />} />
        <Route path="/admin/category/edit" element={<EditCategoryPage />} />
        <Route path="/admin/category/edit/:id" element={<EditCategoryPage />} />

        {/* Product */}
        <Route path="/admin/product/list" element={<ProductList />} />
        <Route path="/admin/product/add" element={<CreateProduct />} />
        <Route path="/admin/product/edit" element={<EditProduct />} />
        <Route path="/admin/products/edit/:id" element={<EditProduct />} />

        {/* Order */}
        <Route path="/admin/order/details" element={<OrderList />} />
        <Route path="/admin/order/pending" element={<PendingOrder />} />
        <Route path="/admin/order/all" element={<OrderList />} />
        <Route path="/admin/order/completed" element={<CompletedOrder />} />
        <Route path="/admin/order/returned" element={<ReturnedOrderList />} />
         <Route path="/admin/order/saleorder" element={<SaleOrder />} />
          <Route path="/admin/order/unverified" element={<UnverifiedOrders />} />
          <Route path="/admin/order/verified" element={<VerifiedOrders />} />
           <Route path="/admin/account/orders-in-process" element={<OrderInProcess />} />

         

        {/* Account */}
        <Route path="/admin/account/delivery-charges" element={<DeliveryChargePage />} />
        <Route path="/admin/account/set-delivery" element={<ManageLogistics />} />
        <Route path="/admin/account/orders-returned" element={<ReturnedOrderList />} />
        <Route path="/admin/account/orders-cancelled" element={<CancelledOrderList />} />
        <Route path="/admin/account/orders-placed" element={<PlacedOrderList />} />
        <Route path="/admin/account/sales-report" element={<SalesReportPage />} />

        {/* Data */}
        <Route path="/admin/data/hot-data" element={<HotLeadsPage />} />
        <Route path="/admin/data/new-data" element={<NewLeadPage />} />
        <Route path="/admin/leads/sales/:id" element={<SalesPage />} />
        <Route path="/admin/data/all-order" element={<OrderList />} />
          <Route path="/admin/update-order/:orderId" element={<UpdateOrderPage />} />
          <Route path="/admin/call-history" element={<CallHistory />} />
          <Route path="/admin/reorder-order/:orderId" element={<UpdateOrderPage />} />


           {/* Appointments */}
        <Route path="/admin/approve-appointments" element={<ApproveAppointment />} />
        <Route path="/admin/scheduled-appointments" element={<ScheduledAppointments />} />
        {/* <Route path="/admin/data/new-data" element={<NewLeadPage />} />
        <Route path="/admin/leads/sales/:id" element={<SalesPage />} />
        <Route path="/admin/data/all-order" element={<OrderList />} />
          <Route path="/admin/update-order/:orderId" element={<UpdateOrderPage />} />
          <Route path="/admin/call-history" element={<CallHistory />} /> */}

        {/* Subordinates */}
        <Route path="/admin/subordinates/manage" element={<SubordinatesPage />} />
        <Route path="/admin/profile/:id" element={<Profile />} />
        <Route path="/admin/subordinates/pending-approvals" element={<PendingApprovalsPage/>} />

        <Route path="/admin/reviews" element={<AdminReviews />}/>
        <Route path="/admin/blogs" element={<AdminBlogs />}/>
      </Route>
    </Routes>
  );
}

function MainRoutes() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return <>{isAdminRoute ? <AdminRoutes /> : <AppContent />}</>;
}

function App() {
  return (
    <Router>
      <CartProvider>
       <MainRoutes />
      </CartProvider>
    </Router>
  );
}

export default App;